<div>
  <i nz-icon nzType="folder" nzTheme="twotone" class="header-icon"></i>&nbsp;<b
    class="header-label"
    >Payroll Approvals</b
  >
</div>
@if (settings.loader) {
<ds-loading></ds-loading>
}
<div class="m-20">
  <div class="fltr_crd">
    <form nz-form [formGroup]="searchForm">
      <div nz-row style="margin-top: 5px">
        <div nz-col nzXs="24" nzSm="4" nzMd="4" nzLg="4" nzXl="4">
          <div class="filter-box">
            <div class="form-label">Year:</div>
            <nz-select
              nzShowSearch
              formControlName="yr_id"
              style="width: 90%; margin-bottom: 30px"
            >
              @for (o of data.years; track o) {
              <nz-option [nzValue]="o.dt_yr" [nzLabel]="o.dt_yr"
                >{{ o.dt_yr }}
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        <div nz-col nzXs="24" nzSm="4" nzMd="4" nzLg="4" nzXl="4">
          <div class="filter-box">
            <div class="form-label">Month:</div>
            <nz-select
              nzShowSearch
              formControlName="mnth_id"
              style="width: 90%; margin-bottom: 30px; margin-left: 10px"
            >
              @for (o of data.mnths; track o) {
              <nz-option [nzValue]="o.mnth_id" [nzLabel]="o.name"> </nz-option>
              }
            </nz-select>
          </div>
        </div>
        <div nz-col nzXs="24" nzSm="3" nzMd="3" nzLg="3" nzXl="3">
          <button
            nz-button
            nzType="primary"
            (click)="getApprovals()"
            style="margin-left: 30px; margin-top: 20px"
          >
            Get Payrolls
          </button>
        </div>
      </div>
    </form>
  </div>

  @if (settings.shwGrid) {
  <div id="data-grid-demo">
    <app-data-grid
      [totalItems]="gridTotals0"
      id="gridContainer"
      [dataSource]="data.pyrlsLst"
      [legacyColumns]="data.columnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="false"
      [columnChooser]="false"
      [allowExport]="false"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [wordWrapEnabled]="true"
    >
      <app-grid-column
        dataField="sno"
        caption="S.No"
        width="50"
        alignment="center"
      ></app-grid-column>
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="data.permissions.updt_in == 1 ? true : false"
        type="buttons"
        [width]="150"
        caption="View"
        cellTemplate="viewTemplate"
      ></app-grid-column>
      <ng-template appGridCell="viewTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="viewEmplyeDetails(data)">
            View Employees
          </div>
        </div></ng-template
      >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="true"
        [width]="150"
        caption="Status"
        cellTemplate="addTemplate"
      ></app-grid-column>
      <ng-template appGridCell="addTemplate" let-data="cell"
        ><div>
          <div
            [ngClass]="data.data.btn_in == 1 ? 'tblApproveBtn' : ''"
            (click)="data.data.btn_in == 1 ? approve(data) : ''"
          >
            {{ data.data.sts_nm }}
          </div>
        </div></ng-template
      >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="settings.shwRjctClmn"
        [width]="150"
        caption="Reject"
        cellTemplate="removeTemplate"
      ></app-grid-column>
      <ng-template appGridCell="removeTemplate" let-data="cell"
        ><div>
          @if (data.data.btn_in == 1) {
          <div class="tblDelBtn" (click)="reject(data)">Reject</div>
          }
        </div></ng-template
      >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="settings.shwCnclClmn"
        [width]="150"
        caption="Cancel Payroll"
        cellTemplate="cancelTemplate"
      ></app-grid-column>
      <ng-template appGridCell="cancelTemplate" let-data="cell"
        ><div>
          @if (data.data.btn_in == 1) {
          <div class="tblDelBtn" (click)="cancel(data)">Cancel Payroll</div>
          }
        </div></ng-template
      >
      @if (settings.shwRjctRsnClmn) {
      <app-grid-column
        [visible]="data.permissions.updt_in == 1 ? true : false"
        [width]="150"
        caption="Payroll Reject Reason"
        dataField="rjct_rsn_txt"
        alignment="left"
      ></app-grid-column>
      }
    </app-data-grid>
  </div>
  }
</div>

<nz-drawer
  [nzBodyStyle]="{
    height: 'calc(100% - 55px)',
    overflow: 'auto',
    'padding-bottom': '53px'
  }"
  [nzMaskClosable]="false"
  [nzWidth]="1400"
  [nzVisible]="settings.shwDetails"
  [nzTitle]="data.sidebarHeading"
  (nzOnClose)="hideForm()"
>
  <ng-container *nzDrawerContent>
    <div nz-row style="margin-top: 5px">
      <div nz-col nzSpan="4">
        <div class="form-label">Employee Type</div>
        <nz-select
          nzShowSearch
          [(ngModel)]="data.emple_type_id"
          style="width: 90%; margin-bottom: 30px"
          (ngModelChange)="filterByEmpleType()"
        >
          <nz-option [nzValue]="zeroVal" nzLabel="All"></nz-option>
          @for (o of data.empleTypeLst; track o) {
          <nz-option [nzValue]="o.emple_type_id" [nzLabel]="o.emple_type_nm">
          </nz-option>
          }
        </nz-select>
      </div>
    </div>
    <div id="data-grid-demo">
      <app-data-grid
        [totalItems]="gridTotals1"
        id="gridContainer"
        style="width: 100%"
        [dataSource]="data.empleLst"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="false"
        [columnChooser]="false"
        [allowExport]="true"
        [exportFileName]="data.excelName"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [wordWrapEnabled]="true"
      >
        <app-grid-column
          dataField="sno"
          caption="S.No"
          width="50"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="dstrt_nm"
          caption="District"
          width="200"
          alignment="left"
        ></app-grid-column>

        <!--
        <app-grid-column dataField="lctn_nm" caption="Rythu Bazar" width="200" alignment="left"></app-grid-column>
        -->

        <app-grid-column
          dataField="emple_nm"
          caption="Employee Name"
          width="200"
          alignment="left"
        ></app-grid-column>

        <app-grid-column
          dataField="emple_nu"
          caption="Employee Number"
          width="150"
          alignment="left"
        ></app-grid-column>

        <app-grid-column
          dataField="dsgns_nm"
          caption="Designation"
          width="200"
          alignment="left"
        ></app-grid-column>

        <app-grid-column
          dataField="emple_type_nm"
          caption="Employee Type"
          width="200"
          alignment="left"
        ></app-grid-column>

        <app-grid-column
          dataField="wk_dy_ct"
          caption="Working Days"
          width="100"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="pyrl_dy_ct"
          caption="Pay Days"
          width="100"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="tl_dy_ct"
          caption="Total Days"
          width="100"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="bsc_slry_at"
          caption="Remuneration"
          width="150"
          alignment="center"
        ></app-grid-column>

        <app-grid-column caption="Employer Contribution">
          <app-grid-column
            dataField="emplr_epf_pct_at"
            caption="EPF"
            width="150"
            alignment="center"
          ></app-grid-column>

          <app-grid-column
            dataField="emplr_esi_pct_at"
            caption="ESI"
            width="150"
            alignment="center"
          ></app-grid-column>
        </app-grid-column>

        <app-grid-column caption="Employee Contribution">
          <app-grid-column
            dataField="emple_epf_pct_at"
            caption="EPF"
            width="150"
            alignment="center"
          ></app-grid-column>

          <app-grid-column
            dataField="emple_esi_pct_at"
            caption="ESI"
            width="150"
            alignment="center"
          ></app-grid-column>
        </app-grid-column>

        <app-grid-column
          dataField="it_pct_at"
          caption="IT Amount"
          width="100"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="pt_at"
          caption="PT"
          width="50"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="gst_pct_at"
          caption="GST"
          width="100"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="nt_at"
          caption="Total to be claimed"
          width="150"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="bnk_nm"
          caption="Bank Name"
          width="200"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="bnk_acnt_nu"
          caption="Bank Amount Number"
          width="200"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="ifsc_cd"
          caption="Bank IFSC Code"
          width="200"
          alignment="center"
        ></app-grid-column>

        <app-grid-column
          dataField="bnk_brnch_nm"
          caption="Bank Branch Name"
          width="200"
          alignment="center"
        ></app-grid-column>
      </app-data-grid>
    </div>
  </ng-container>
</nz-drawer>
<nz-modal
  [(nzVisible)]="settings.isVisible"
  [nzContent]="modalContent"
  nzTitle="Are you sure want to reject this payroll ?"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
>
  <ng-template #modalContent>
    <div>
      <nz-form-label nzRequired>Enter Reason For Rejection</nz-form-label>
      <div class="filter-box">
        <textarea rows="3" nz-input [(ngModel)]="data.rjctn_rsn_tx"></textarea>
      </div>
    </div>
  </ng-template>
</nz-modal>
